import { render, staticRenderFns } from "./CreateScreenCluster.vue?vue&type=template&id=4fea3b68&"
import script from "./CreateScreenCluster.vue?vue&type=script&lang=ts&"
export * from "./CreateScreenCluster.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports